import AddThisWrapper from './AddThisWrapper.vue'
import BirthDateBreakdown from './BirthDateBreakdown.vue'
import DateForm from './DateForm/DateForm.vue'
// import FutureOccasions from './FutureOccasions/FutureOccasions.vue'
import LocaleChanger from './LocaleChanger.vue'
// import ModalWindow from './ModalWindow.vue'
import Occasion from './Occasion.vue'
import SectionScroller from './SectionScroller.vue'
import SelectedOccasionsList from './SelectedOccasionsList.vue'
import ShareSidebar from './ShareSidebar.vue'
import SideControls from './SideControls.vue'

export default {
  AddThisWrapper,
  BirthDateBreakdown,
  DateForm,
  // FutureOccasions,
  LocaleChanger,
  // ModalWindow,
  Occasion,
  SectionScroller,
  SelectedOccasionsList,
  ShareSidebar,
  SideControls,
}
